import BaseProxy from './Proxy';

export default class PasswordProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/password', parameters);
  }

  getPasswordConstraints() {
    return this.submit('get', `${this.endpoint}/constraints`);
  }

  changePassword(params) {
    return this.submit('post', `${this.endpoint}/change`, params);
  }
}
